/**
 * Whether a back-office sidebar item should light up for the current path. Pulled out of
 * `Layout` so the match rule itself is unit-tested: a bare `pathname.startsWith(item.to)`
 * also lit up 'Menu' (`/back-office/menu`) while on Menu Builder (`/back-office/menu-builder`)
 * — one path string-prefixes the other without actually being its parent route (#34).
 */
export function isNavItemActive(pathname, item) {
  if (item.exact) return pathname === item.to;
  return pathname === item.to || pathname.startsWith(`${item.to}/`);
}
